<div
  *ngIf="paymentAccount"
  id="organizationRiderPaymentAccountListItem-container-card-{{ paymentAccount.id }}"
  class="card-container"
  [ngClass]="{ selected: selected, unverified: isCreditCardValidationEnabled && !paymentAccount.verified }"
>
  <div class="info">
    <div class="row verification">
      <p id="organizationRiderPaymentAccountListItem-text-cardAlertMsg-{{ paymentAccount.id }}">
        <ng-container *ngIf="isUnverified">
          <mat-icon class="material-icons-outlined">info</mat-icon> Needs verification. Select card to verify.
        </ng-container>

        <ng-container *ngIf="isExpired">
          <mat-icon class="material-icons-outlined">info</mat-icon> Expired
        </ng-container>
        &nbsp;
      </p>
    </div>
    <div class="row description">
      <p class="nickname" id="organizationRiderPaymentAccountListItem-heading-id-{{ paymentAccount.id }}" data-private>
        {{ paymentAccount.userDescription }}
      </p>
      <span class="card-logo">
        <mat-icon
          id="organizationRiderPaymentAccountListItem-image-cardLogo-{{ paymentAccount.id }}"
          [svgIcon]="creditCardLogoSVG"
        ></mat-icon>
      </span>
      <button
        id="organizationRiderPaymentAccountListItem-button-edit-{{ paymentAccount.id }}"
        mat-icon-button
        color="primary"
        (click)="handleEditPaymentAccount()"
        aria-label="Edit Payment Account"
      >
        <mat-icon class="material-icons-outlined">create</mat-icon>
      </button>
    </div>
    <p
      class="number"
      id="organizationRiderPaymentAccountListItem-text-cardNumber-{{ paymentAccount.id }}"
      [innerHTML]="getHiddenCardNumberWithEnding(paymentAccount)"
      data-private
    ></p>
    <div class="row">
      <div>
        <small class="contrast-gray">Card Holder</small>
        <p id="organizationRiderPaymentAccountListItem-text-nameOnCard-{{ paymentAccount.id }}" data-private>
          {{ paymentAccount.billingFirstName }} {{ paymentAccount.billingLastName }}
        </p>
      </div>
      <div class="expires">
        <small class="contrast-gray">Expires</small>
        <p id="organizationRiderPaymentAccountListItem-text-expirationDate-{{ paymentAccount.id }}" data-private>{{ formatCardExpiration(paymentAccount.cardExpiration) }}</p>
      </div>
    </div>
    <div class="created-by">
      <small id="organizationRiderPaymentAccountListItem-text-createdBy-{{ paymentAccount.id }}"> Created by: {{ paymentAccount.createdBy }} </small>
    </div>
  </div>
</div>
